import { useState, useCallback } from 'react';
import tripService from '../services/tripService';

export function useTrips(vehicleId, onError) {
  const [trips, setTrips]   = useState([]);
  const [loading, setLoading] = useState(false);

  const loadTrips = useCallback(async (filters = {}) => {
    setLoading(true);
    try {
      const data = await tripService.getAll({ vehicle: vehicleId, ...filters });
      setTrips(data);
    } catch (err) {
      if (typeof onError === 'function') onError(err);
      setTrips([]);
    } finally {
      setLoading(false);
    }
  }, [vehicleId, onError]);

  return { trips, loading, loadTrips };
}